//@ts-nocheck

//Fallback values
const presetCurrencyCode = 'USD';
const presetCurrencySymbol = '$';
const presetFractionDigits = 2;
const presetLocale = 'en-US';

//Get the preset config
const getPresetConfig = () => {
  return {
    currencyCode: presetCurrencyCode,
    currencySymbol: presetCurrencySymbol,
    fractionDigits: presetFractionDigits,
    locale: presetLocale
  };
};

//Gets the tenant info from the store
const getTenantInfo = () => {
  try {
    const tenant = JSON.parse(localStorage.getItem('tenantData'));

    return {
      ...tenant
    };
  } catch (error) {
    return {};
  }
};

//Get the configuration
export const getConfig = (config = {}) => {
  const presetConfig = getPresetConfig();
  const { sellingcurrency = {} } = getTenantInfo();
  let settings = { ...presetConfig, ...config };

  if (Object.keys(sellingcurrency).length > 0) {
    const { currencycode, currencysymbol } = sellingcurrency;
    const tenantConfig = {
      currencyCode: currencycode,
      currencySymbol: currencysymbol
    };

    settings = { ...presetConfig, ...tenantConfig, ...config };
  }

  return settings;
};

/**
 * Returns a formatted currency string.
 *
 * @param {Object} amount - The amount to be formatted
 * @param {Object} config - The configuration options
 * @return {string}  The formatted currency string
 */
export const formatCurrency = (amount = 0, config = {}) => {
  const currencyConfig = getConfig(config) || {};
  const { currencyCode, currencySymbol, fractionDigits, locale } =
    currencyConfig;

  // Use Intl.NumberFormat to format the number according to the specified options
  const formattedAmount = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  }).format(amount);

  // Remove the currency symbol added by Intl.NumberFormat and trim any spaces - XGE-1724
  //  This removes "$CA" at the start of the returned amount if the currency doesn't match the current user's locale
  const numberFormat = formattedAmount
    .replace(/^[^0-9]+/, '') // Remove non-digits from beginning
    .replace(/[^0-9]+$/, ''); // Remove non-digits from end

  // Add negative sign if amount is negative
  return `${amount < 0 ? '-' : ''}${currencySymbol}${numberFormat} ${currencyCode}`;
};

/**
 * Rounds a number to two decimal places.
 *
 * This function takes a number as a parameter, converts it to a Number object and
 * checks if it is a finite number. If the number is not finite, it returns 0.
 * Otherwise, it rounds the number to two decimal places using the Math.round() method
 * and returns the result.
 *
 * @param {number|string} value - The number to be rounded
 * @returns {number} - The rounded number
 */
export const roundCurrency = (value) => {
  const num = Number(value);
  if (!isFinite(num)) return 0;
  return Math.round((num + Number.EPSILON) * 100) / 100;
};
